import { styled } from '@mui/material';
import { TextareaAutosize } from '@mui/base/TextareaAutosize';

const grey = {
	50: '#F3F6F9',
	100: '#E5EAF2',
	200: '#DAE2ED',
	300: '#C7D0DD',
	400: '#B0B8C4',
	500: '#9DA8B7',
	600: '#6B7A90',
	700: '#434D5B',
	800: '#303740',
	900: '#1C2025',
};
const Textarea = styled(TextareaAutosize)(() => `
        width: 100%;
        font-size: 0.875rem;
        font-weight: 400;
        line-height: 1.5;
        padding: 8px 12px;
        border-radius: 8px;
        color: ${grey[900]};
        background: white;
        border: 1px solid ${grey[200]};
        box-shadow: 0px 2px 2px ${grey[50]};`
);

export default Textarea;